import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MarkAsUnreadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mark_as_unread"}/>
}
